export const dev_env = false;
export const version = 2;
export const server = dev_env ? 'http://globaldata.local.192.168.4.40.nip.io' : 'https://globaldata.link';

export default {
    mapbox: 'pk.eyJ1IjoiZ2hzLXJpZGEiLCJhIjoiY2tpcTU0ZW9hMGQzYTJybXYxcGU5NHRrdSJ9.-KPLGweAXcpYfrJJoUB5NA',
    server: server,
    url: `${server}/api/v${version}`,
    version: version,
    website: 'https://ghscompanies.com'
}
